import { render, staticRenderFns } from "./CodeTab.vue?vue&type=template&id=ab744b76"
import script from "./CodeTab.vue?vue&type=script&lang=js"
export * from "./CodeTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports